// @flow

import axios from 'axios';
import { getFlowBaseUrl } from '../../config/config';

export default function getDeletedWorkflowApi(projectId: string, startDate: string, endDate: string): Promise<Object> {
  return axios.get(`${getFlowBaseUrl()}projects/${projectId}/deletedplanflowsummary?startDate=${startDate}&endDate=${endDate}`, { withCredentials: true });
}
